import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faSearch } from '@fortawesome/pro-regular-svg-icons';

import SearchByPhoneNumberForm from './SearchByPhoneNumberForm';

/**
 * @author OmerKosar
 */
const ClientListing = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50 },
			{ Header: 'connectedCompanyId', accessor: 'connectedCompanyId', filterType: FilterType.number, width: 50 },
			{ Header: 'clientName', accessor: 'clientName', filterType: FilterType.string, width: 90 },
			{ Header: 'companyName', accessor: 'companyName', filterType: FilterType.string, width: 90, show: false },
			{ Header: 'clientEmail', accessor: 'clientEmail', filterType: FilterType.string, width: 100 },
			{ Header: 'clientType', accessor: 'clientType', filterType: FilterType.string, width: 90 },
			{
				Header: 'cohortAgg',
				accessor: 'cohortAgg',
				filterType: FilterType.enum,
				enumName: ENUMS.COHORTS
			},
			{
				Header: 'cohortIntg',
				accessor: 'cohortIntg',
				filterType: FilterType.enum,
				enumName: ENUMS.COHORTS
			},
			{ Header: 'countryLabel', accessor: 'countryLabel', filterType: FilterType.string },
			{
				Header: 'clientPhone',
				accessor: 'clientPhone',
				width: 90,
				filterType: FilterType.string,
				renderCell: ListComponents.PHONE,
				showOnMap: true
			},
			{
				Header: 'clientAddress',
				accessor: 'clientAddress',
				filterType: FilterType.string,
				width: 95,
				show: false
			},
			{ Header: 'usageMode', accessor: 'usageMode', filterType: FilterType.string },
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				width: 90,
				renderCell: ListComponents.DATETIME,
				customFilterOptions: [FilterAction.between, FilterAction.on]
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.number,
				renderCell: ListComponents.CURRENCY,
				width: 50
			},
			{
				Header: 'codRemainingAmount',
				accessor: 'codRemainingAmount',
				filterType: FilterType.number,
				renderCell: ListComponents.CURRENCY,
				width: 100
			},
			{
				Header: 'extraCredits',
				accessor: 'extraCredit',
				filterType: FilterType.number,
				renderCell: ListComponents.CURRENCY,
				width: 50
			},
			{
				Header: 'CRDocumentLabel',
				accessor: 'CRDocumentURL',
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_FILE
			},
			{
				Header: 'civilIDDocument',
				accessor: 'civilIDDocument',
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_FILE
			},
			{
				Header: 'CRDocStatus',
				accessor: 'CRDocStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CR_DOC_STATUS
			},
			{
				Header: 'CRDocumentUploadDate',
				accessor: 'CRDocumentUploadDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'FLDocumentLabel',
				accessor: 'FLDocumentURL',
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_FILE
			},
			{
				Header: 'FLDocStatus',
				accessor: 'FLDocStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CR_DOC_STATUS
			},
			{
				Header: 'FLDocumentUploadDate',
				accessor: 'FLDocumentUploadDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.string,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'isRefundAllowed',
				accessor: 'isRefundAllowed',
				filterType: FilterType.enum,
				enumName: ENUMS.REFUND_ALLOWED_STATUS
			},
			{
				Header: 'otoFeePerOrder',
				accessor: 'otoFeePerOrder',
				filterType: FilterType.number
			},
			{
				Header: 'avgShipmentPerMonth',
				accessor: 'averageShipment',
				filterType: FilterType.number
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	return (
		<div>
			<PageHeader title="clientListing">
				<Button
					icon={faSearch}
					label="searchByPhoneNumber"
					onClick={() => NiceModal.show(SearchByPhoneNumberForm)}
				/>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.CLIENT_LISTING}
				columns={columns}
				defaultSort={defaultSort}
				infiniteScroll
				fetchUrl={ADMIN.CLIENT.GET_CLIENT_LISTINGS}
				actionObjectType={ACTION_OBJECT_TYPES.CLIENT}
			/>
		</div>
	);
};

export default ClientListing;
